import React from 'react';

import Text from '@lightspeed/cirrus-text';
import { Alert } from '@lightspeed/flame/Alert';

const PageError = ({ children }) => (
  <div className="react-page__listing">
    <Alert type="danger" noCloseBtn>
      <Text>{children}</Text>
    </Alert>
  </div>
);

export default PageError;
